import FirstBox from './FirstBox';
import B2BInfoData from './B2BInfoData';


const ShowB2BInfo = ({ clientData, selectedCountry }) => {
    return <>
        <FirstBox />
        <br />
        <B2BInfoData
            b2bInfoData={clientData.b2b_table}
            clientData={clientData}
            selectedCountry={selectedCountry}
        />
    </>
};

export default ShowB2BInfo;
